import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { TextGenerateEffect } from "@/components/ui/text-generate-effect";
import { RainbowButton } from "@/components/ui/rainbow-button";

export const Hero = () => {
  return (
    <section className="pt-24 md:pt-32 pb-16 px-4 overflow-hidden">
      <div className="container mx-auto text-center relative">
        <div className="absolute inset-0 -z-10">
          <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-secondary/20 to-accent/20 animate-pulse" />
        </div>

        <TextGenerateEffect 
          words="DBTAI"
          className="text-4xl md:text-7xl font-bold gradient-text mb-4"
          duration={0.3}
        />
        
        <h1 className="text-3xl md:text-6xl font-bold mb-6 gradient-text animate-fade-in">
          Transform Your Emotional Well-being with AI-Powered DBT Support
        </h1>
        
        <p className="text-base md:text-xl text-foreground/80 max-w-2xl mx-auto mb-8 animate-fade-in delay-150 px-4">
          Experience the power of Dialectical Behavior Therapy (DBT) with personalized AI support, 
          guided journaling, and evidence-based tools for emotional regulation. Available 24/7 to help you 
          build a life worth living.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in delay-300 px-4">
          <RainbowButton className="transform hover:scale-105 transition-transform w-full sm:w-auto" asChild>
            <Link to="/chat" aria-label="Start your DBT journey with AI support">
              Start Your Journey
            </Link>
          </RainbowButton>
          <Button variant="secondary" className="transform hover:scale-105 transition-transform w-full sm:w-auto" asChild>
            <Link to="/safety-plan" aria-label="Create your personalized safety plan">
              Create Safety Plan
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
